const USER_ROLES = {
  orgAdmin: 'org-admin',
  orgUser: 'org-user',
  superAdmin: 'admin'
}

Object.freeze(USER_ROLES)

export default USER_ROLES
